import type { AccumulatorReplyMessage } from '@/store/forwardAccumulator/api/multiPass/requestForwardAccumulator.model.ts';
import type { ForwardAccumulatorQuote } from '@/store/forwardAccumulator/state.ts';
import type { QuoteWithPrice } from '@/utils/rfs/type.ts';
import { toPredealCheck } from '@/utils/rfs/utils.ts';

export const createForwardAccumulatorQuote = (
  message: QuoteWithPrice<AccumulatorReplyMessage>,
): ForwardAccumulatorQuote => {
  return {
    forward: { ask: message.AccumulatorQuoteReply.Forward.Ask, bid: message.AccumulatorQuoteReply.Forward.Bid },
    greeks: {
      deltaCcy1: message.AccumulatorQuoteReply.DeltaCcy1,
      deltaCcy2: message.AccumulatorQuoteReply.DeltaCcy2,
      vegaCcy1: message.AccumulatorQuoteReply.VegaCcy1,
      vegaCcy2: message.AccumulatorQuoteReply.VegaCcy2,
    },
    premiumData: {
      premiumCcy1: {
        ask: message.AccumulatorQuoteReply.PremiumCcy1.Ask,
        bid: message.AccumulatorQuoteReply.PremiumCcy1.Bid,
      },
      premiumCcy2: {
        ask: message.AccumulatorQuoteReply.PremiumCcy2.Ask,
        bid: message.AccumulatorQuoteReply.PremiumCcy2.Bid,
      },
      premiumPctCcy1: message.AccumulatorQuoteReply.PremiumPctCcy1,
      premiumPctCcy2: message.AccumulatorQuoteReply.PremiumPctCcy2,
      premiumRateStoCcy1Mid: message.AccumulatorQuoteReply.PremiumRateStoCcy1Mid,
      premiumRateStoCcy2Mid: message.AccumulatorQuoteReply.PremiumRateStoCcy2Mid,
    },
    isEligibleToPremiumRateStoMid:
      message.AccumulatorQuoteReply.PremiumRateStoCcy1Mid > 0 &&
      message.AccumulatorQuoteReply.PremiumRateStoCcy2Mid > 0,
    quoteId: message.AccumulatorQuoteReply.QuoteId,
    quoteType: message.AccumulatorQuoteReply.QuoteType,
    tiering: message.AccumulatorQuoteReply.Tiering,
    quoteContribution: message.AccumulatorQuoteReply.QuoteContribution ?? 'Manual',
    rfsWindow: message.AccumulatorQuoteReply.RfsWindow,
    hedge: {
      maturityDate: message.AccumulatorQuoteReply.Hedge?.[0]?.MaturityDate,
      rateMid: message.AccumulatorQuoteReply.Hedge?.[0]?.RateMid,
      notionalAmount: message.AccumulatorQuoteReply.Hedge?.[0]?.NotionalAmount,
      notionalCurrency: message.AccumulatorQuoteReply.Hedge?.[0]?.NotionalCurrency,
    },
    marginData: {
      markupCcy1: message.AccumulatorQuoteReply.MarkupCcy1,
      markupCcy2: message.AccumulatorQuoteReply.MarkupCcy2,
    },
    predealChecks: message.AccumulatorQuoteReply.PredealChecks.map(toPredealCheck),
    spot: { ask: message.AccumulatorQuoteReply.Spot.Ask, bid: message.AccumulatorQuoteReply.Spot.Bid },
    swapPoints: {
      ask: message.AccumulatorQuoteReply.SwapPoints.Ask,
      bid: message.AccumulatorQuoteReply.SwapPoints.Bid,
    },
    volatility: message.AccumulatorQuoteReply.Volatility,
    backTimestamp: message.Timestamp,
    frontTimestamp: message.workerTimestamp,
  };
};
